// extracted by mini-css-extract-plugin
export default {"title":"k_-z","warning":"l_-z","sizeOptionsLegendText":"m_-z"};